<template lang="html">
  <div class="slide how-to-audio">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect ref="frame" id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="bg">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-1280w.jpg`" media="(max-width: 1280px)">
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-1920w.jpg`" media="(max-width: 1920px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/silhouette/Silouette1.jpg`" />
            </picture>
          </foreignObject>
        </g>
      </g>
    </svg>
    <div ref="dialogue">
      <SceneDialogue
        :width="0.9"
        :fontSize="20"
        :styles="{padding: `1.25em`, lineHeight: `3em`, textAlign: 'center'}"
        :tx="0.5" :ty="0.275">
        <p class='minion bold header' style='margin: 0; font-size: 2em;'>
          Navajo translation by Charles Littlesalt, whose knowledge and oral
          histories of his father, Max Littlesalt, bring history into the present.
        </p>
      </SceneDialogue>
      <SceneDialogue
        :width="0.8"
        :fontSize="20"
        :bg="'none'"
        :styles="{lineHeight: `3em`, textAlign: 'center'}"
        :tx="0.5" :ty="0.625">
        <span class='minion bold header' style='margin: 0; font-size: 1.75em; color: white;'>
          Press this button
          <span @touchstart="toggleAudio">
            <span class="audio-toggle" @click="toggleAudio">
            <svg id="speaker" xmlns="http://www.w3.org/2000/svg" width="51.031" height="42.026" viewBox="0 0 51.031 42.026">
              <path :fill="audioActive ? '#e38900' : 'black'" d="M45.178,22.159a1.472,1.472,0,0,0-1.591.18L28.968,34.014H17.5a1.5,1.5,0,0,0-1.5,1.5V50.521a1.5,1.5,0,0,0,1.5,1.5H28.968L43.587,63.7a1.526,1.526,0,0,0,.931.33,1.785,1.785,0,0,0,.66-.15,1.5,1.5,0,0,0,.841-1.351V23.509A1.5,1.5,0,0,0,45.178,22.159ZM43.016,59.4,30.439,49.35a1.527,1.527,0,0,0-.931-.329H19V37.015H29.508a1.534,1.534,0,0,0,.931-.33L43.016,26.631Z" transform="translate(-16 -22.001)" />
              <path :fill="audioActive ? '#e38900' : 'black'" d="M66.279,22.218A1.508,1.508,0,1,0,64.718,24.8C72.433,29.42,76,35.212,76,43.016s-3.572,13.6-11.287,18.217a1.53,1.53,0,0,0-.51,2.071,1.563,1.563,0,0,0,1.291.721,1.444,1.444,0,0,0,.78-.21c8.554-5.132,12.728-11.8,12.728-20.8S74.833,27.35,66.279,22.218Z" transform="translate(-27.976 -22)" />
              <path :fill="audioActive ? '#e38900' : 'black'" d="M64.96,55.99h.54a1.437,1.437,0,0,0,1.111-.51,12.329,12.329,0,0,0,0-16.987,1.5,1.5,0,0,0-1.651-.51,1.53,1.53,0,0,0-.961,1.5V54.49A1.529,1.529,0,0,0,64.96,55.99Z" transform="translate(-27.978 -25.97)" />
            </svg>
          </span>
          </span>
          to activate audio, then turn up your device volume
          to hear Navajo translations as you move through the book.
        </span>
      </SceneDialogue>
      <SceneDialogue
        :width="0.25"
        :fontSize="30"
        :bg="'none'"
        :styles="{
          lineHeight: `1.5em`, 'border-radius': '1em', opacity: audioActive ? 1 : 0,
          padding: '0.2em 0', textAlign: 'center', background: 'white'
        }"
        :tx="0.5" :ty="0.833">
          Audio is active!
      </SceneDialogue>
    </div>
    <!-- <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/narration/blank.mp3`" /> -->
  </div>
</template>

<script>
import AudioToggle from "../AudioToggle"
import {TweenLite} from "gsap"
import Template from "./Template.vue"
import {mapState, mapActions} from "vuex"

export default {
  extends: Template,
  mounted() {
    const {bg, dialogue} = this.$refs
    TweenLite.set(bg, {opacity: 0})
    TweenLite.set(dialogue, {opacity: 0})
    this.tl.add(TweenLite.to(bg, 1, {opacity: 1}), 0)
    this.tl.add(TweenLite.to(dialogue, 1, {opacity: 1}), 0)
  },
  computed: {
    ...mapState(["audioActive"]),
  },
  methods: {
    enter() {this.tl.play()},
    ...mapActions(['setAudioActive']),
    toggleAudio(e) {
      this.setAudioActive(!this.audioActive)
    },
  },
  components: {
    AudioToggle
  }
}
</script>

<style>
.how-to-audio .audio-toggle { display: inline-flex; margin: 0em 0.25em; width: 1.5em; height: 1.5em; vertical-align: middle; }
.how-to-audio .audio-toggle svg { display: block; width: 1em; height: 1em; }
</style>